
      import RadioDot from './radio-dot.vue'
      import type { App, Plugin } from 'vue'

      export const RadioDotPlugin: Plugin = {
        install(app: App) {
          app.component('RadioDot', RadioDot)
        },
      }
      export { RadioDot }
      